import React from 'react';
import cx from 'classnames';
import NextLink from 'next/link';

import {Text} from '#component/base';
import {SUPPORT_EMAIL} from '#constant/app';
import {formattedDate} from '#util';
import {formatCurrency} from '#util/formatCurrency';

import {OrderTotalProps} from './OrderTotal.types';

import {orderDetailsBody} from './OrderDetail.css';
import {
  orderDetailDisclaimerWrapper,
  orderTotalDisclaimer,
  orderTotalDisclaimerLink,
  orderTotalShippingTextSmall,
  orderTotalSummaryHeading,
  orderTotalSummaryWrapper,
  orderTotalWrapper,
} from './OrderTotal.css';

const OrderTotals = ({order, isNotUpcomingOrder = false}: OrderTotalProps) => {
  return (
    <>
      <div className={orderTotalWrapper}>
        <div>
          {
            <Text variant="body" className={orderDetailsBody}>
              Subtotal
            </Text>
          }
        </div>
        <div>
          {
            <Text variant="body" className={orderDetailsBody}>
              {formatCurrency('USD', order?.subTotal)}
            </Text>
          }
        </div>
        <div>
          {
            <Text variant="body" className={orderDetailsBody}>
              Discounts
            </Text>
          }
        </div>
        <div>
          {
            <Text variant="body" className={orderDetailsBody}>
              {order?.discountTotal === 0
                ? '$0'
                : '-' + formatCurrency('USD', order?.discountTotal)}
            </Text>
          }
        </div>

        {isNotUpcomingOrder && (
          <>
            <div>
              {
                <Text variant="body" className={orderDetailsBody}>
                  Total Tax
                </Text>
              }
            </div>
            <div>
              {
                <Text variant="body" className={orderDetailsBody}>
                  {formatCurrency('USD', order?.taxTotal)}
                </Text>
              }
            </div>
          </>
        )}

        <div>
          {
            <Text variant="body" className={orderDetailsBody}>
              Shipping <small className={orderTotalShippingTextSmall}>(standard)</small>
            </Text>
          }
        </div>
        <div>
          {
            <Text variant="body" className={orderDetailsBody}>
              {order?.shippingTotal === 0 ? 'Free' : formatCurrency('USD', order?.shippingTotal)}
            </Text>
          }
        </div>
      </div>
      <div className={orderTotalSummaryWrapper}>
        <div>
          {isNotUpcomingOrder ? (
            <Text variant="body" className={cx(orderDetailsBody, orderTotalSummaryHeading)}>
              Total
            </Text>
          ) : (
            <Text variant="body" className={cx(orderDetailsBody, orderTotalSummaryHeading)}>
              To be billed on {order && formattedDate(order?.billingDate)}
            </Text>
          )}
        </div>
        <div>
          {
            <Text variant="body" className={cx(orderDetailsBody, orderTotalSummaryHeading)}>
              {formatCurrency('USD', order?.total)}
            </Text>
          }
        </div>
        {!isNotUpcomingOrder && (
          <>
            <div></div>
            <div>
              {
                <Text variant="body" className={orderDetailsBody}>
                  + applicable local taxes
                </Text>
              }
            </div>
          </>
        )}
      </div>
      {!isNotUpcomingOrder && (
        <div className={orderDetailDisclaimerWrapper}>
          {
            <Text variant="body" className={cx(orderDetailsBody, orderTotalDisclaimer)}>
              {'If you would like to make any changes to your next order, please reach out to us at' +
                ' '}
              <NextLink href={`mailto:${SUPPORT_EMAIL || ''}`} passHref>
                <Text
                  variant="body"
                  className={cx(orderDetailsBody, orderTotalDisclaimer, orderTotalDisclaimerLink)}>
                  {SUPPORT_EMAIL}
                </Text>
              </NextLink>
            </Text>
          }
        </div>
      )}
    </>
  );
};

export default OrderTotals;
